function nextSort(current, field) {
  return { field, direction: current.field === field && current.direction === 'desc' ? 'asc' : 'desc' }
}
export function sortedRows(rows, sort) {
  if (!sort.field) return rows
  return [...rows].sort((a, b) => {
    const left = a[sort.field], right = b[sort.field]
    const comparison = typeof left === 'number' && typeof right === 'number'
      ? left - right : String(left ?? '').localeCompare(String(right ?? ''), 'pt-BR', { numeric: true })
    return sort.direction === 'asc' ? comparison : -comparison
  })
}
export default function TableSort({ field, sort, onChange, children }) {
  const active = field === sort.field
  return <button type="button" className={`cd-sort${active ? ' active' : ''}`} onClick={() => onChange(nextSort(sort, field))}
    title={`Ordenar por ${children}: ${active && sort.direction === 'desc' ? 'crescente' : 'decrescente'}`}>
    {children}<svg className={`cd-sort-triangle${active && sort.direction === 'asc' ? ' ascending' : ''}`} width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M1 3h10L6 10z" fill="currentColor" /></svg>
  </button>
}
